<style scoped>
.search-block {
    padding: 15px 0 0 15px;
}
.search-btn-block {
    padding: 15px 0 ;
}
</style>


<template>
<div class="main container-fluid">
    <div class="row search-block">
        <div class="col-6">
            <input class="aquazor-input" v-model="input_search_text" v-on:keyup.enter="searchText">
        </div>
        <div class="col-2 search-btn-block"><a class="aquazor-btn" @click="searchText">Найти</a></div>
    </div>
    <div class="row user_table">
        <div class="user_table_row first_row" v-if="!load_list">
            <div class="user_table_cell">ID</div>
            <div class="user_table_cell">E-mail</div>
            <div class="user_table_cell">Регистрация</div>
            <div class="user_table_cell">Последнее посещение</div>
            <div class="user_table_cell">Online</div>
            <div class="user_table_cell">Коментарии</div>
            <div class="user_table_cell">Блокировка</div>
            <div class="user_table_cell"></div>
            <div class="user_table_cell"></div>
        </div>
        <user-list-component v-if="!load_list"
            v-for="(user, index) in users" 
            :user="user" 
            :key="user.id_user" 
            v-on:deleteRow="deleteRow(index)" />
    </div>
    <div class="loader" v-if="load_list">
        <loader-component />
    </div>
    <div class=" col-12 empty-users-list-block" v-if="empty_list">
        <p>У вас нет пользователей, печаль ...</p>
    </div>
    <div class=" col-12 empty-users-list-block" v-if="this.users.length == 0 && !load_list">
        <p>Нет данных</p>
    </div>
    <div class="col-12 aquazor-pagination-block" v-if="this.users.length > 0">
        <paginate-component :totalItems="total_items" :max-visible-pages="5" :page="pagination_index" :items-per-page="count_view_rows" v-on:page-change="changePagination"></paginate-component>
    </div>
</div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import axios from 'axios'
import {
    store
} from '@/store'
import userRow from './elements/user_row.vue'
import loader from './elements/loader.vue'
import vuePaginate from 'vue-ads-pagination'
import '@/assets/css/aquazor-pagination.css'

//   $store.getters.layout = 'app-layout'

export default {
    name: 'Accounts',
    created() {
        get_users_list(this)
        this.setinterval_get_users_list = setInterval(() => {
            if (!this.action_load)
                get_users_list(this)
        }, config.UPDATE_PERIOD);
    },
    data() {
        return {
            users: [],
            load_list: true,
            empty_list: false,
            setinterval_get_users_list: null,
            pagination_index: 0,
            count_view_rows: 20,
            total_items: 0,
            input_search_text: '',
            search_text: '',
            action_load: false
        }
    },
    methods: {
        deleteRow: function (index_row) {
            this.users.splice(index_row, 1)
        },
        changePagination: function(page) {
            if (page != this.pagination_index) {
                this.load_list = true
                this.action_load = true
                this.pagination_index = page
                get_users_list(this)
            }
        },
        searchText: function () {
            this.load_list = true
            this.action_load = true
            this.search_text = this.input_search_text
            get_users_list(this)
            this.pagination_index = 0
        }
    },
    components: {
        'user-list-component': userRow,
        'loader-component': loader,
        'paginate-component': vuePaginate
    },
    beforeDestroy() {},
    destroyed() {
        clearInterval(this.setinterval_get_users_list)
    }
}

function get_users_list(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('page', vue_obj.pagination_index)
        post_data.set('count', vue_obj.count_view_rows)
        post_data.set('search_text', vue_obj.search_text)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/list',
                data: post_data
            })
            .then(function (response) {
                vue_obj.users = response.data.users
                vue_obj.total_items = response.data.count_users
                vue_obj.load_list = false
                this.action_load = false
            })
            .catch(function (error) {

            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/aquazor-users.vue